export const Routes = {
  home: '/',
  about: '/about',
  contact: '/contact',
  getStarted: '/get-started',
};